import { Question } from '../types/questionnaire.types';

export const isQuestionAnswered = (
  question: Question,
  response: string | undefined
): boolean => {
  if (!response || response.trim() === '') return false;

  if (question.type === 'matrix_scale' && question.matrixRows) {
    try {
      const matrixAnswers = JSON.parse(response);
      return question.matrixRows.every((row) => matrixAnswers[row.id]);
    } catch {
      return false;
    }
  }

  if (question.type === 'ranking' && question.answers) {
    try {
      const rankedAnswers = JSON.parse(response);
      // Check if all answers have been ranked
      return rankedAnswers.length === question.answers.length;
    } catch {
      return false;
    }
  }

  if (
    question.type === 'multiple_choice_checkbox' &&
    question.maxSelections !== undefined &&
    question.maxSelections !== null
  ) {
    // Se maxSelections está definido, valida se o número exato foi selecionado
    const selectedAnswers = response
      ? response.split(',').filter((id) => id.trim() !== '')
      : [];
    return selectedAnswers.length === question.maxSelections;
  }

  return true;
};

export const isFormValid = (
  questions: Question[],
  responses: Record<string, string>
): boolean => {
  return questions.every((question) => {
    const response = responses[question.id];

    // Se a questão é obrigatória, deve estar respondida corretamente
    if (question.required) {
      return isQuestionAnswered(question, response);
    }

    // Se a questão tem maxSelections e foi parcialmente respondida,
    // deve ter o número exato de seleções
    if (
      question.type === 'multiple_choice_checkbox' &&
      question.maxSelections !== undefined &&
      question.maxSelections !== null &&
      response &&
      response.trim() !== ''
    ) {
      const selectedAnswers = response
        .split(',')
        .filter((id) => id.trim() !== '');
      return selectedAnswers.length === question.maxSelections;
    }

    return true;
  });
};

export const getAnsweredCount = (
  questions: Question[],
  responses: Record<string, string>
): number => {
  return questions.filter((q) => isQuestionAnswered(q, responses[q.id])).length;
};

export const getProgressPercentage = (
  questions: Question[],
  responses: Record<string, string>
): number => {
  return (getAnsweredCount(questions, responses) / questions.length) * 100;
};
